import { defineStore, getActivePinia } from "pinia";
import { useAlertStore } from "../stores/alert.store";
import { useNotification } from "@kyvg/vue3-notification";
import { useBettorStore } from "./bettor.store";
const notification = useNotification();

import axios from "axios";
const baseUrl = process.env.VUE_APP_NODE_ENV === 'local' ? process.env.VUE_APP_LIST_CHECKER_API_URL : `${window.location.origin}`;
const headers = {
  headers: {
    Accept: "application/json",
    "Content-Type": "multipart/form-data",
    "api-token": process.env.VUE_APP_LIST_CHECKER_API_TOKEN,
  },
};
const resetAllPiniaStores = () => {
  const activeStores = Object.keys(getActivePinia().state.value);
  activeStores.forEach((store) => {
    if (store != "isLoading") {
      getActivePinia()._s.get(store).$reset();
    }
  });
};
const permissions = {
  superadmin: [
    "check-bettors-list",
    "acitivity-list",
    "acitivity-list-edit",
    "settings",
    "acitivity-potential-incidents",
    "acitivity-confirmed-incidents",
    "acitivity-resolved-incidents",
    "acitivity-archive-incidents",
    "settings-add-user",
    "settings-add-monitoringUser",
  ],
  monitoring_user: [
    "check-bettors-list",
    "acitivity-list",
    "acitivity-list-edit",
    "settings",
    "acitivity-potential-incidents",
    "acitivity-confirmed-incidents",
    "acitivity-resolved-incidents",
    "acitivity-archive-incidents",
    "settings-add-user",
  ],
  admin: [
    "check-bettors-list",
    "acitivity-list",
    "acitivity-list-edit",
    "acitivity-potential-incidents",
    "acitivity-confirmed-incidents",
    "acitivity-resolved-incidents",
    "acitivity-archive-incidents",
    "settings",
    "settings-add-user",
    "settings-add-monitoringUser",
    "update-admin-role",
  ],
  report_editor: [
    "check-bettors-list",
    "acitivity-list",
    "acitivity-list-edit",
    "acitivity-potential-incidents",
    "acitivity-confirmed-incidents",
    "acitivity-resolved-incidents",
    "acitivity-archive-incidents",
  ],
  report_viewer: [
    "check-bettors-list",
    "acitivity-list",
    "acitivity-potential-incidents",
    "acitivity-confirmed-incidents",
    "acitivity-resolved-incidents",
    "acitivity-archive-incidents",
  ],
};

export const useAuthStore = defineStore({
  id: "auth",
  state: () => ({
    // initialize state from local storage to enable user to stay logged in
    user: JSON.parse(localStorage.getItem("user")),
    activationMessage: "",
    activationStatus: false,
    clientName: "",
    buildVersion: "",
    environment: "",
    passwordStatus: null,
    showServerModal: true,
    csvAccept: localStorage.getItem("csvAccept") ? parseInt(localStorage.getItem("csvAccept")) : 0,
    checkLeagues: "",
    opt_authenticate: localStorage.getItem("opt_authenticate") ?? null,
    show_update_password: localStorage.getItem("show_update_password") ?? false
  }),
  getters: {},
  actions: {
    async login(username, password) {
      const alertStore = useAlertStore();
      try {
        await axios
          .post(
            `${baseUrl}/login`,
            {
              username,
              password,
            },
            headers
          )
          .then((user) => {
            if (!user.data.error) {
              user.data.permissions = permissions[user.data.role];
              this.otp_enabled = user.data.otp_enabled;
              this.otp_verified = user.data.otp_verified;
              this.user = user.data;
              this.passwordStatus = user.data.pass_status;
              this.csvAccept = user.data.csv_acceptance;
              this.opt_authenticate =  false;
              localStorage.setItem('csvAccept', this.csvAccept);
              localStorage.setItem("user", JSON.stringify(user.data));
              if(user.data?.otp_enabled == 0){
                this.show_update_password = true;
                this.opt_authenticate = true;  
                localStorage.setItem('show_update_password',this.show_update_password);
                localStorage.setItem("opt_authenticate", JSON.stringify(this.opt_authenticate));
            }
              alertStore.success(user.data.message);
            } else {
              alertStore.error(user.data.message);
            }
            
          }).then(()=>{ 
              this.verifyActivationKey({ license_key: "" })
          });
      } catch (error) {
        let message = error.response.data.message?? error.response.data.detail
        notification.notify({
          title: "Error!",
          text: message,
          type: "error",
        });
      }
    },
   
    updateRoleInStore(newRole) {
      this.user.role = newRole;
      this.user.permissions = permissions[newRole];
      localStorage.setItem('user', JSON.stringify(this.user));
      window.location.reload(); // Reload the site to apply new role restrictions
    },
    updateTimeZone(timeZone) {
      this.user.timezone = timeZone;
      localStorage.setItem('user', JSON.stringify(this.user));
    },
    async verifyActivationKey(data) {
      const alertStore = useAlertStore();
      try {
        await axios
          .post(`${baseUrl}/verify-license`, JSON.stringify(data), headers)
          .then((res) => {
            if (!res.data.is_valid_key) {
              localStorage.removeItem("activationStatus");
              this.activationStatus = false;
              
              alertStore.error(res.data.message);
            } else {
              localStorage.setItem("activationStatus", true);
              this.activationStatus = true;
              this.clientName = res.data.client_name;
              this.checkLeagues = res.data.restricted_leagues_query_mode;
              this.buildVersion = res.data.app_version;
              this.environment = res.data.environment;
              alertStore.success(res.data.message);
            }

            const bettorStore = useBettorStore();
            const { logout } = useAuthStore();
            const application_status = response.headers?.get("application-status")
            const responseStatus = application_status;
            if(bettorStore.responseStatus !== responseStatus){ 
              bettorStore.responseStatus = responseStatus; 
              if(bettorStore.responseStatus ===  200){ 
                logout(); 
              }
            }
            this.activationMessage = res.data.message;
          });
      } catch (error) {
        alertStore.error(error);
      }
    },
    logout() {
      localStorage.clear();
      resetAllPiniaStores();
    },
  },
});
